export const CURRENCY_OPTIONS = [
  { code: 'RUB', label: 'Российский рубль', symbol: '₽' },
  { code: 'USD', label: 'Доллар США', symbol: '$' },
  { code: 'EUR', label: 'Евро', symbol: '€' },
  { code: 'KZT', label: 'Казахстанский тенге', symbol: '₸' },
  { code: 'BYN', label: 'Белорусский рубль', symbol: 'Br' },
  { code: 'AMD', label: 'Армянский драм', symbol: '֏' },
  { code: 'GEL', label: 'Грузинский лари', symbol: '₾' },
  { code: 'GBP', label: 'Фунт стерлингов', symbol: '£' },
  { code: 'ILS', label: 'Новый израильский шекель', symbol: '₪' },
  { code: 'AED', label: 'Дирхам ОАЭ', symbol: 'AED' },
];

const SUPPORTED_CODES = new Set(CURRENCY_OPTIONS.map(({ code }) => code));

export const normalizeCurrency = (currency) => {
  const code = String(currency || 'RUB').trim().toUpperCase();
  return SUPPORTED_CODES.has(code) ? code : 'RUB';
};

export const currencySymbol = (currency) => (
  CURRENCY_OPTIONS.find(({ code }) => code === normalizeCurrency(currency))?.symbol || '₽'
);

export const formatMoney = (value, currency = 'RUB', options = {}) => {
  const amount = Number(value) || 0;
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: normalizeCurrency(currency),
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    ...options,
  }).format(amount);
};
